import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type CardProps = {
  children: ReactNode;
  className?: string;
  title?: string;
  titleExtra?: ReactNode;
};

export function Card({ children, className, title, titleExtra }: CardProps) {
  return (
    <section
      className={cn(
        'overflow-hidden rounded-2xl border border-slate-200/70 bg-white/90 shadow-card backdrop-blur-sm ring-1 ring-transparent transition-all duration-300 hover:shadow-card-hover hover:ring-teal-500/[0.08]',
        className
      )}
    >
      {title ? (
        <div className="relative flex flex-wrap items-center justify-between gap-2 border-b border-slate-100/90 bg-gradient-to-r from-slate-50/95 via-white to-teal-50/30 px-5 py-3.5">
          <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-teal-400/40 to-transparent" aria-hidden />
          <h2 className="text-sm font-semibold tracking-tight text-slate-800">{title}</h2>
          {titleExtra ? <div className="flex shrink-0 items-center gap-2">{titleExtra}</div> : null}
        </div>
      ) : null}
      <div className={cn(title ? 'p-5 sm:p-6' : 'p-5 sm:p-6')}>{children}</div>
    </section>
  );
}
